// 产品手动分类
import { getAction } from '@/api/manage'

export default {
  data() {
    return {
      list: [],
      // userId: this.$ls.get('fromId'),
    }
  },
  created() {
    if (this.listData) {
      this.list = this.listData
    } else {
      this.getProduct()
    }
  },
  computed: {
    categoryList() {
      const arr = this.dataFilter()
      return arr
    },
  },
  methods: {
    getProduct() {
      let data = {
        // userId: this.userId,
      }
      if (this.hotelId) {
        data.hotelId = this.hotelId
      }
      getAction(`/pc/home/qryPmsProductPageByUserId`, data).then((res) => {
        this.list = res.result.productPageDetail
      })
    },
    dataFilter() {
      // productType: 1 商品 2 活动 3 服务
      let arr = [
        {
          type: '2',
          name: 'activity',
          theme: 'btn-theme',
          list: [],
        },
        {
          type: '1',
          name: 'product',
          theme: 'btn-theme2',
          list: [],
        },
        {
          type: '3',
          name: 'service',
          theme: 'btn-white',
          list: [],
        },
      ]
      if (this.list.length > 0) {
        arr.forEach((x) => {
          x.list = this.list.filter((item) => item.productType === x.type)
        })
        return arr
      }
      return []
    },
  },
}
